<template>
	<div class="container">
		<div class="fixed_top" v-show="isGoTop" @click.stop.prevent="goTop">
			<img style="width:35px;height:35px;" src="../assets/img/go_top.png" />
		</div>
	</div>
</template>

<script>
export default {
	components:{
		//
	},
	data() {
		return {
			isGoTop: false,
		}
	},
	created(){
		//
	},
	mounted() {
		window.addEventListener("scroll", this.handleScroll);
	},
	watch: {
		//
	},
	methods: {
		handleScroll() {
			let that = this;
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			if (scrollTop >= 200) {
				that.isGoTop = true;
			}else{
				that.isGoTop = false;
			}
		},
		goTop() {
			let that = this;
			let currentY = document.documentElement.scrollTop || document.body.scrollTop;
			that.scrollAnimation(currentY, 0);
		},
		scrollAnimation(currentY, targetY) {
			let needScrollTop = targetY - currentY
		    let _currentY = currentY
		    setTimeout(() => {
		        let dist = Math.ceil(needScrollTop / 10)
		        _currentY += dist
		        window.scrollTo(_currentY, currentY)
		        if (needScrollTop > 10 || needScrollTop < -10) {
		          this.scrollAnimation(_currentY, targetY)
		        } else {
		          window.scrollTo(_currentY, targetY)
		        }
		     }, 1);
		}
	},
	destroyed() {
		document.removeEventListener('scroll', this.handleScroll);
	}
}
</script>

<style>
</style>
